<template>
    <button
      class="button is-outlined"
    @click="startCaseAction()"
      :disabled="item.isDisabled" v-translate>
        Start reporting case
    </button>
</template>
<script>
  import { mapActions } from 'vuex'
  import { errorHandler } from '@/mixins/mixins'

  export default {
    name: 'start-reporting-case-component',
    mixins: [errorHandler],
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    methods: {
      ...mapActions([
        'startReportingCase',
        'successMessage'
      ]),
      startCaseAction () {
        this.startReportingCase(this.item.id).then((response) => {
          this.item.caseId = response.data.case_id
          this.item.inProgress = true
          this.successMessage('Reporting case started successfully!')
        }).catch((err) => {
          this.handleError(err)
        })
      }
    }
  }
</script>
